module.exports = __webpack_public_path__ + "img/Monte_Kope_92.0d42cad9.jpg";